const COOKIES = {};
let listOfCookies = {};
COOKIES.init = () => {
  const browserCookies = document.cookie.split(';');
  for (let i = 0; i < browserCookies.length; i++) {
    let cookie = browserCookies[i].split('=');
    listOfCookies[(cookie[0] + '').trim()] = unescape(
      cookie.slice(1).join('=')
    );
  }
};

COOKIES.get = (value) => {
  return listOfCookies[value];
};

COOKIES.getRootDomain = () => {
  const hostname = location?.hostname;
  if (!hostname) {
    return '';
  }

  const domainPattern = /[^.]+\.co\.uk$|[^.]+\.[^.]+$/;
  const domain = hostname.match(domainPattern);

  if (!domain?.[0]) {
    return hostname;
  }

  return `.${domain[0]}`;
};

COOKIES.set = (key, value) => {
  document.cookie = `${key}=${value}; domain=${COOKIES.getRootDomain()}; SameSite=Strict; Secure`;
};

COOKIES.remove = (value) => {
  document.cookie = `${value}=; Max-Age=0; domain=${COOKIES.getRootDomain()}; SameSite=Strict; Secure`;
};

export default COOKIES;
